import { isValidAppUiSettingValue } from '../app-ui-settings/validate.js';
const isTree = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
export function fieldPayloadOf(prefix, values) {
    const root = {};
    const start = `${prefix}.`;
    for (const [key, value] of Object.entries(values)) {
        if (!key.startsWith(start))
            continue;
        const parts = key.slice(start.length).split('.');
        const leaf = parts.pop() ?? '';
        let node = root;
        for (const part of parts) {
            const child = node[part];
            if (isTree(child))
                node = child;
            else {
                const created = {};
                node[part] = created;
                node = created;
            }
        }
        node[leaf] = value;
    }
    return root;
}
export function fieldValuesOf(prefix, payload) {
    const result = new Map();
    const walk = (node, path) => {
        for (const [key, value] of Object.entries(node)) {
            const next = `${path}.${key}`;
            if (isTree(value))
                walk(value, next);
            else
                result.set(next, value);
        }
    };
    if (isTree(payload))
        walk(payload, prefix);
    return result;
}
const definitionMap = (definitions) => new Map(definitions.map((d) => [d.key, d]));
export function fieldDefaultPayload(prefix, definitions) {
    return fieldPayloadOf(prefix, Object.fromEntries(definitions.map((definition) => [definition.key, definition.defaultValue])));
}
export function validateFieldPayload(name, prefix, definitions, payload) {
    if (!isTree(payload))
        return { ok: false, errors: [`${name}: must be an object`] };
    const byKey = definitionMap(definitions);
    const errors = [];
    const values = {};
    for (const [key, value] of fieldValuesOf(prefix, payload)) {
        const definition = byKey.get(key);
        const path = key.slice(prefix.length + 1);
        if (!definition)
            errors.push(`${path}: unknown field`);
        else if (!isValidAppUiSettingValue(definition, value))
            errors.push(`${path}: not a valid value for "${definition.label}"`);
        else
            values[key] = value;
    }
    return errors.length
        ? { ok: false, errors }
        : { ok: true, payload: fieldPayloadOf(prefix, values), errors };
}
export function mergeFieldPayload(prefix, definitions, builtIn, received) {
    if (!isTree(received))
        return null;
    const byKey = definitionMap(definitions);
    const values = {};
    for (const definition of definitions)
        values[definition.key] = definition.defaultValue;
    for (const layer of [builtIn, received]) {
        for (const [key, value] of fieldValuesOf(prefix, layer)) {
            const definition = byKey.get(key);
            if (definition && isValidAppUiSettingValue(definition, value))
                values[key] = value;
        }
    }
    return fieldPayloadOf(prefix, values);
}
export function resolveFieldValues(prefix, definitions, payload) {
    const found = fieldValuesOf(prefix, payload);
    const result = new Map();
    for (const definition of definitions) {
        const value = found.get(definition.key);
        result.set(definition.key, value !== undefined && isValidAppUiSettingValue(definition, value)
            ? value
            : definition.defaultValue);
    }
    return result;
}
//# sourceMappingURL=fields.js.map